$(document).ready(function () {

    const reviewStars = document.querySelector('.review-mask-area');
    var tabTopPosition = 0;

    setTimeout(() => {
        var tabSection = document.getElementById('product-resources');

        // Return early if the tab section isn't found to avoid errors when clicking the review stars
        if (!tabSection) return;

        function windowSize() {
            tabTopPosition = tabSection.offsetTop;
        }

        window.onresize = windowSize;
        windowSize();
    }, 2000);

    reviewStars.addEventListener('click', (event) => {
        if (window.innerWidth >= 1280) {
            document.querySelector(`#product-resources [data-tab-name="reviews"] button`).click();
        } else {
            document.querySelector(`#product-resources [data-tab-name="reviews"]`).click();
        }

        $('html, body').animate({
            scrollTop: tabTopPosition
        }, 300);
    });

    // Lazy-load Trustpilot widget when it scrolls into view
    var tpWidget = document.querySelector('.review-block__wrapper .trustpilot-widget');
    if (tpWidget) {
        function loadTrustpilotScript(callback) {
            if (window.Trustpilot) {
                callback();
                return;
            }
            var script = document.createElement('script');
            script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            script.onload = callback;
            document.head.appendChild(script);
        }

        function initTrustpilotWidget() {
            loadTrustpilotScript(function () {
                if (window.Trustpilot) {
                    window.Trustpilot.loadFromElement(tpWidget);
                }
            });
        }

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries, obs) {
                if (entries[0].isIntersecting) {
                    obs.disconnect();
                    initTrustpilotWidget();
                }
            }, { rootMargin: '200px' });
            observer.observe(tpWidget);
        } else {
            setTimeout(initTrustpilotWidget, 1500);
        }
    }

});